<template>
  <div class="context-sample">
    <h3>Context サンプル</h3>
    <EmitValueComponent @emit-value="handleEmitValue" />
  </div>
</template>

<script>
import Vue from 'vue'
import EmitValueComponent from '@/components/EmitValueComponent.vue'

export default {
  components: {
    EmitValueComponent
  },
  setup(props, context) {
    console.log(context.attrs)
    console.log(context.slots)
    console.log(context.refs)
    console.log(context.emit)
    console.log(context.parent)
    console.log(context.root)
    console.log(context.root.$myMethod)

    const handleEmitValue = value => alert(`emit-value: ${value}`)

    return {
      handleEmitValue
    }
  }
}
</script>
